import { render, staticRenderFns } from "./Surveys.vue?vue&type=template&id=539f754a&scoped=true&"
import script from "./Surveys.vue?vue&type=script&lang=js&"
export * from "./Surveys.vue?vue&type=script&lang=js&"
import style0 from "./Surveys.vue?vue&type=style&index=0&id=539f754a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539f754a",
  null
  
)

component.options.__file = "Surveys.vue"
export default component.exports